<div class="dropdown-item" [class.active]="selected" [class.tick]="!disableTick" *ngIf="hide === false" [attr.selectedid]="selectedid">
    <ng-content></ng-content> 
</div>
